import {
  Box,
  Flex,
  Image,
  Text,
  Stat,
  StatLabel,
  StatNumber,
  StatHelpText,
  Wrap,
  WrapItem
} from '@chakra-ui/react';
import React, { useEffect } from 'react';
import { AiOutlineCalendar } from 'react-icons/ai';
import { IoInformation } from 'react-icons/io5';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';

import PageContainer from '../../components/pageContainer/PageContainer';
import { getPrograms } from '../../slice/programsSlice';

function Programs() {
  const dispatch = useDispatch();
  const programs = useSelector(state => state.programs.programs);

  useEffect(() => {
    dispatch(getPrograms());
  }, [dispatch]);

  const createImg = (img, programUrl, htmlFile, _id) => {
    const imgSrc = URL.createObjectURL(new Blob([Buffer.from(img, 'base64')]));
    const programImg = <Image objectFit='contain' h='200px' w='100%' src={imgSrc}/>;

    if (programUrl) {
      return (
        <a href={programUrl}>
          {programImg}
        </a>
      );
    } else if (htmlFile === 'UPLOADED') {
      return (
        <NavLink to={`/programs-index/${_id}`}>
          {programImg}
        </NavLink>
      );
    } else {
      return programImg;
    }
  };

  const createCard = (program, i) => {
    return (
      <WrapItem key={i} w='400px' h='350px' overflow='auto' borderRadius='4px' border='1px' borderColor='blackAlpha.300'>
        <Box>
          <Stat margin='10px'>
            <StatLabel>
              {createImg(program.programImg, program.programUrl, program.htmlFile, program._id)}
            </StatLabel>
            <StatNumber fontWeight='500' textAlign='left'>{program.programName}</StatNumber>
            <StatHelpText textAlign='left'>
              <Flex flexDir='row'>
                <Box><AiOutlineCalendar height='16px' width='16px' size='16px'/></Box>
                <Text position='relative' bottom='1px'>{program.programDate}</Text>
              </Flex>
              <br/>
              <Flex maxW='100%' flexDir='row'>
                <Box><IoInformation height='16px' width='16px' size='16px'/></Box>
                <Text overflowWrap='anywhere' position='relative' bottom='2px'>{program.programDescription}</Text>
              </Flex>
            </StatHelpText>
          </Stat>
        </Box>
      </WrapItem>
    );
  };

  return (
    <PageContainer>
      <Text color='#377DFF' fontSize='3xl' fontWeight={500}>Programs</Text>
      <Wrap justify='center' align='flex-start'>
        {programs.map((program, i) => createCard(program, i))}
      </Wrap>
    </PageContainer>
  );
}

export default Programs;
